import React from 'react';
import { Link } from 'react-router-dom';
import { Home } from 'lucide-react';
import { PAGE_BANNER_DEFAULT_IMAGE } from '../data/homeData';

function PageBanner({
  eyebrow,
  title,
  lead,
  tagline,
  breadcrumbs = [],
  image = PAGE_BANNER_DEFAULT_IMAGE,
  imagePosition = 'center',
  align = 'left',
  size = 'default',
  children,
}) {
  const alignClass = align === 'center' ? 'page-banner--center' : 'page-banner--left';
  const sizeClass = size === 'compact' ? 'page-banner--compact' : '';

  return (
    <section
      className={`page-banner page-banner--image ${alignClass} ${sizeClass}`.trim()}
      aria-labelledby="page-banner-title"
    >
      <div
        className="page-banner-bg"
        aria-hidden="true"
        style={{ '--banner-position': imagePosition }}
      >
        <img src={image} alt="" loading="eager" decoding="async" />
        <div className="page-banner-overlay" />
      </div>

      <div className="page-banner-inner">
        {breadcrumbs.length > 0 && (
          <nav className="page-banner-crumb" aria-label="Breadcrumb">
            <Link to="/" className="page-banner-crumb-link page-banner-crumb-home">
              <Home size={14} aria-hidden="true" />
              Home
            </Link>
            {breadcrumbs.map((crumb, index) => {
              const isLast = index === breadcrumbs.length - 1;

              return (
                <span key={`${crumb.label}-${index}`} className="page-banner-crumb-item">
                  <span className="page-banner-crumb-sep" aria-hidden="true">&gt;</span>
                  {crumb.to && !isLast ? (
                    <Link to={crumb.to} className="page-banner-crumb-link">
                      {crumb.label}
                    </Link>
                  ) : (
                    <span className="page-banner-crumb-current" aria-current="page">
                      {crumb.label}
                    </span>
                  )}
                </span>
              );
            })}
          </nav>
        )}

        <div className="page-banner-body">
          {eyebrow && <p className="page-banner-eyebrow">{eyebrow}</p>}
          {tagline && <p className="page-banner-tagline">{tagline}</p>}
          <h1 id="page-banner-title" className="page-banner-title">{title}</h1>
          {lead && <p className="page-banner-lead">{lead}</p>}
          {children}
        </div>
      </div>
    </section>
  );
}

export default PageBanner;
